import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { setGenderOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'

export function* getGenderOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getGenderOptions,
    ])
    const { entity } = response
    yield put(setGenderOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getGenderOptions() error: ${e}`))
  }
}

export function* getGenderOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getGenderOptions)
}
